<template>
  <div
    :class="[ns.b(), ns.is(`${shadow}-shadow`), ns.is('bordered', bordered)]"
    data-test-name="card"
    data-test-variant=""
    data-test-state=""
  >
    <div v-if="$slots.header || header" :class="[ns.e('header'), headerClass]">
      <slot name="header">{{ header }}</slot>
    </div>
    <div :class="[ns.e('body'), bodyClass]" :style="bodyStyle">
      <slot />
    </div>
    <div v-if="$slots.footer || footer" :class="[ns.e('footer'), footerClass]">
      <slot name="footer">{{ footer }}</slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useNamespace } from '@bigin/hooks'
import { cardProps } from './card'

defineOptions({
  name: 'BCard',
})

defineProps(cardProps)

const ns = useNamespace('card')
</script>
